import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {
    Button, CardActions, CardContent, TextField,
    CardHeader, Grid, Select, FormControl, MenuItem, InputLabel, FormHelperText, FormControlLabel
} from "@mui/material";
import {setModal} from "../../../../../Common/App";
import {DialogCard, Loader} from "../../../../../../Components";
import {addEntity, updateEntity} from "../../../Redux/Action";
import Checkbox from "@mui/material/Checkbox";

const initialData = {
    id: null,
    entity_name: '',
    module:"",
    display_name:"",
    workflow_type: '',
    is_template: false
}
export const EntityModal = ({item, setItems}) => {

    const dispatch = useDispatch();
    const [disabled, setDisabled] = useState(false);
    const [errors, setErrors] = useState({});
    const [, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(initialData);

    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);

    const handleSaveOrUpdate = async () => {
        setIsLoading(true);
        if (data.id) {
            await updateEntity({ dispatch, data }).then((res) => {
                setIsLoading(false);
                if (res.success) {
                    setData(initialData);
                    setItems((prev) => prev.map((item) => (item.id === res.data?.id ? res.data : item)));
                    dispatch(setModal({component:null, open:false}));
                }
                setErrors(res.errors);
                setMessage(res.message);
            });
        } else {
            await addEntity({ dispatch, data }).then((res) => {
                setIsLoading(false);
                if (res.success) {
                    setData(initialData);
                    setItems((prev) => [...prev, res.data]);
                    dispatch(setModal({component:null, open:false}));
                }
                setErrors(res.errors);
                setMessage(res.message);
            });
        }
    };

    const handleChange = (e) => {
        setErrors({});
        setDisabled(false);
        const {name, value} = e.target;
        setData({...data, [name]: value});
    }

    return (
        <DialogCard>
            <CardHeader 
                title="Entity"
                avatar={<Loader isLoading={isLoading} type={"linear"} />}
            />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Entity Name"
                            value={data?.entity_name || ''}
                            name="entity_name"
                            onChange={(e) => handleChange(e)}
                            variant="outlined"
                            helperText={errors?.entity_name}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth variant="outlined" error={!!errors?.module}>
                            <InputLabel htmlFor="location-select">Module</InputLabel>
                            <Select
                                value={data?.module || ''}
                                onChange={(e) => handleChange(e)}
                                label="Location"
                                inputProps={{
                                    name: 'module',
                                    id: 'location-select',
                                }}
                                variant="outlined"
                            >
                                <MenuItem key={""} >Select Location</MenuItem>
                                <MenuItem key={"CRM"} value={"CRM"}>CRM</MenuItem>
                                <MenuItem key={"HRMS"} value={"HRMS"} >HRMS</MenuItem>
                            </Select>
                            <FormHelperText>{errors?.module}</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth variant="outlined" error={!!errors?.workflow_type}>
                            <InputLabel htmlFor="workflow-type-select">Workflow Type</InputLabel>
                            <Select
                                value={data?.workflow_type || ''}
                                onChange={(e) => handleChange(e)}
                                label="Workflow Type"
                                inputProps={{
                                    name: 'workflow_type',
                                    id: 'workflow-type-select',
                                }}
                                variant="outlined"
                            >
                                <MenuItem key={""} >Select Workflow Type</MenuItem>
                                <MenuItem key={"LINEAR"} value={"LINEAR"}>Linear</MenuItem>
                                <MenuItem key={"STATE_MACHINE"} value={"STATE_MACHINE"}>State Machine</MenuItem>
                                <MenuItem key={"PARALLEL"} value={"PARALLEL"} disabled={true}>Parallel</MenuItem>
                                <MenuItem key={"RULE_DRIVEN"} value={"RULE_DRIVEN"} disabled={true}>Rule Driven</MenuItem>
                                <MenuItem key={"ADHOC"} value={"ADHOC"} disabled={true}>Adhoc</MenuItem>
                            </Select>
                            <FormHelperText>{errors?.workflow_type}</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            multiline
                            rows={2}
                            fullWidth
                            label="Display Name"
                            value={data?.display_name || ''}
                            name="display_name"
                            onChange={(e) => handleChange(e)}
                            variant="outlined"
                            helperText={errors?.display_name}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl error={!!errors?.is_template}>
                            <FormControlLabel
                                label="Is Template"
                                labelPlacement="end" // ensures label is on the right
                                control={
                                    <Checkbox
                                        id="is-template-checkbox"
                                        name="is_template"
                                        checked={!!data?.is_template}
                                        onChange={(e) =>
                                            handleChange({
                                                target: {
                                                    name: "is_template",
                                                    value: e.target.checked,
                                                },
                                            })
                                        }
                                        color="primary"
                                    />
                                }
                            />
                            <FormHelperText>{errors?.is_template}</FormHelperText>
                        </FormControl>
                    </Grid>
                </Grid>
            </CardContent>
            <CardActions>
                <Button onClick={() => dispatch(setModal({component:null, open:false}))}>Cancel</Button>
                <Button disabled={disabled} variant="contained" color={'primary'} onClick={ handleSaveOrUpdate }>{ data['id'] ? 'Update' : 'Add'}</Button>
            </CardActions>
        </DialogCard>
    )
}